import { Plugin, PluginKey } from '@tiptap/pm/state';
import { DecorationSet } from '@tiptap/pm/view';
import { ySyncPluginKey, absolutePositionToRelativePosition } from 'y-prosemirror';
import { recreateTransform } from '@fellow/prosemirror-recreate-transform';
import { createPreCommentHighlightDecoration } from './preCommentHighlightDecoration';

const key = new PluginKey('preCommentHighlight');

export default new Plugin({
  key,
  state: {
    init() {
      return {
        decoration: DecorationSet.empty,
        yjsFrom: null,
        yjsTo: null,
      };
    },

    apply(tr, stateValue, _oldState, newState) {
      const meta = tr.getMeta('preCommentHighlight');
      const [decoration] = stateValue.decoration.find();
      const { preCommentRange, highlight } = tr.getMeta('preCommentHighlight') || {};
      const YState = ySyncPluginKey.getState(newState);
      const collabEnabled = !!YState;

      switch (meta?.action) {
        case 'add':
          if (collabEnabled) {
            const fromPos = absolutePositionToRelativePosition(
              preCommentRange.from,
              YState.type,
              YState.binding.mapping
            );
            const toPos = absolutePositionToRelativePosition(
              preCommentRange.to,
              YState.type,
              YState.binding.mapping
            );
            return {
              ...stateValue,
              decoration: createPreCommentHighlightDecoration({
                state: newState,
                from: fromPos,
                to: toPos,
                id: highlight || decoration?.spec['data-highlighted'],
              }),
              yjsFrom: fromPos,
              yjsTo: toPos,
            };
          }
          return {
            ...stateValue,
            decoration: createPreCommentHighlightDecoration({
              state: newState,
              from: preCommentRange.from,
              to: preCommentRange.to,
              id: highlight || decoration?.spec['data-highlighted'],
            }),
            yjsFrom: null,
            yjsTo: null,
          };
        case 'remove':
          return {
            decoration: DecorationSet.empty,
            yjsFrom: null,
            yjsTo: null,
          };
        default:
          if (decoration && decoration.from !== 0 && decoration.to !== 0) {
            if (!collabEnabled) {
              return {
                ...stateValue,
                decoration: stateValue.decoration.map(tr.mapping, tr.doc),
              };
            }
            const mapping = recreateTransform(tr.before, tr.doc, {
              complexSteps: false,
              wordDiffs: false,
              simplifyDiff: true,
            }).mapping;

            return {
              ...stateValue,
              decoration: stateValue.decoration.map(mapping, tr.doc),
            };
          }
          return {
            decoration: DecorationSet.empty,
            yjsFrom: null,
            yjsTo: null,
          };
      }
    },
  },
  props: {
    decorations(state) {
      return this.getState(state)?.decoration;
    },
  },
});
